import { StoreState } from "@/redux/RootReducer";

export const headAgreementCommonSelectors = {
  getCopyToNextYear: (state: StoreState) =>
    state.headAgreementCommon.copyToNextYear,
};
